<template>
  <div v-show="foundCountry">
    <GmapMap
      :center="{ lat: 0, lng: 0 }"
      ref="mapRef"
      :zoom="4"
      :options="mapOptions"
      map-type-id="terrain"
      style="width: 100%; height: 370px; margin: auto; position: relative;"
    >
    </GmapMap>
  </div>
</template>

<script>

import {gmapApi} from 'vue2-google-maps'

export default {
  name: "CountryMap",
  props: ["provider"],
  data() {
    return {
      foundCountry: false,
      mapOptions: {
        disableDefaultUI: true,
        styles: [
          { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "white" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "white" }]
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "white" }]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [{ color: "white" }]
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{ color: "white" }]
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "white" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "white" }]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "black" }]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "black" }]
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#75C4CF" }]
          },
          {
            featureType: "road.highway",
            elementType: "labels",
            stylers:[{visibility: "off"}]
          },
          {
            featureType: "road.arterial",
            elementType: "labels",
            stylers: [{visibility: "off"}]
          },
          {
            featureType: "road.local",
            elementType: "labels",
            stylers: [{visibility: "off"}]
          },
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "administrative.province",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "water",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          }
        ]
      }
    };
  },
  computed: {
    google: gmapApi
  },
  watch: {
    provider: {
      handler: function(val) {
        this.searchLocation();
      },
      deep: true
    },
    google() {
      this.searchLocation();
    }
  },
  updated(){
    this.searchLocation();
  },
  methods: {
    searchLocation: function() {
      if (this.provider == undefined) return;
      if (this.google == null) return;
      var geocoder = new this.google.maps.Geocoder();
      var target = { address: this.provider.offices[0].country.name };
      geocoder.geocode(target, (results, status) => {
        this.$refs.mapRef.$mapPromise.then(map => {
          this.foundCountry = true;
          if (status == this.google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
          }
        });
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/charts/CountryMap.vue